$(document).on('DOMSubtreeModified', 'tr', function(){
    $(this).attr('class', $(this).find('.js-anchor-background:first').attr('data-tr-color'))
})